import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { updateXeroSignupForm } from './services';
import { IXeroSignUpFormReqParams } from '../types';

export const useXeroFormUpdateMutation = (
  options?: UseMutationOptions<
    AxiosResponse,
    AxiosError,
    IXeroSignUpFormReqParams
  >,
) =>
  useMutation({
    mutationFn: updateXeroSignupForm,
    ...options,
  });
